import { z as zod } from 'zod';
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { DetailSchema, RelatedInfoSchema } from "@/app/features/shared/types/schema";

const MutableShowroomSchema = zod.object({
    id: zod.string(),
    title: zod.string(),
    subtitle: zod.string().nullish(),
    description: zod.string().nullish(),
    images: zod.array(MediaRefSchema),
});

export const ExhibitionDetailSchema = zod.object({
    id: zod.string().nullable(),
    title: zod.string(),
    subtitle: zod.string().nullish(),
    excerpt: zod.string(),
    promoImage: MediaRefSchema,
    flyerImage: MediaRefSchema.nullish(),
    isHighlight: zod.boolean(),
    order: zod.number(),
    startDate: zod.string().nullish(),
    endDate: zod.string().nullish(),
    details: zod.array(DetailSchema.partial({ id: true })).nullish(),
    showroom: MutableShowroomSchema.nullish(),
    relatedInfos: zod.array(RelatedInfoSchema).nullish(),
});

export const ExhibitionOverviewItemSchema = zod.object({
    id: zod.string(),
    title: zod.string().min(1, 'Titel darf nicht leer sein'),
    excerpt: zod.string().min(1, 'Kurzbeschreibung darf nicht leer sein'),
    promoImage: MediaRefSchema.nullish(),
});
